import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarItem = _resolveComponent("SidebarItem")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, {
    width: "208px",
    class: "system-menu-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { style: {"height":"calc(100vh - 64px)"} }, {
        default: _withCtx(() => [
          (_ctx.showMenu && _ctx.store.state.user.userInfo.userinfo.role)
            ? (_openBlock(), _createBlock(_component_el_menu, {
                key: 0,
                uniqueOpened: true,
                "default-active": _ctx.defaultActive,
                class: "system-menu-vertical",
                "background-color": "#1F2442",
                "text-color": "#8F91A0",
                "active-text-color": "#4E7CFF",
                mode: "vertical",
                onSelect: _ctx.getMenuVal
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (route) => {
                    return (_openBlock(), _createBlock(_component_SidebarItem, {
                      key: route.path,
                      item: route,
                      "base-path": route.path
                    }, null, 8, ["item", "base-path"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active", "onSelect"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}